import formatEvents from './formatEvents';
import themeEditor from './themeEditor';

export default () => {
  formatEvents();
  themeEditor();
};